/* Origin Smart Plus advert page — progressive enhancement only.
   1. Responsive film: pick ONE of the three compositions (16:9, 1:1, 9:16)
      from the viewport before anything downloads, keep progress across a
      deliberate layout change, never autoplay.
   2. Finish picker on the product panel.
   Without this script the page still shows the wide film with native controls. */
(function () {
  'use strict';

  var RATIOS = ['16x9', '1x1', '9x16'];

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Viewport → composition. Portrait (w/h ≤ 0.8) takes the vertical cut,
     wide desktop (≥ 900px and w/h ≥ 1.35) the landscape cut, everything else square. */
  function pickRatio() {
    var w = window.innerWidth;
    var h = window.innerHeight;
    var r = w / h;
    if (r <= 0.8) return '9x16';
    if (w >= 900 && r >= 1.35) return '16x9';
    return '1x1';
  }

  function initPlayer(root) {
    var sources;
    try {
      sources = JSON.parse(root.getAttribute('data-oa-sources') || '{}');
    } catch (e) {
      return;
    }

    var frame = root.querySelector('[data-oa-frame]');
    var video = root.querySelector('video');
    var play = root.querySelector('[data-oa-play]');
    if (!frame || !video) return;

    var current = null;
    var lastW = window.innerWidth;
    var lastH = window.innerHeight;
    var timer = null;
    var tracked = {};

    function available(r) {
      return sources[r] && sources[r].src;
    }

    function choose() {
      var r = pickRatio();
      if (available(r)) return r;
      for (var i = 0; i < RATIOS.length; i++) {
        if (available(RATIOS[i])) return RATIOS[i];
      }
      return null;
    }

    function apply(ratio, keepProgress) {
      if (!ratio || ratio === current) return;
      var s = sources[ratio];
      var wasPlaying = keepProgress && !video.paused && !video.ended;
      var t = keepProgress ? video.currentTime : 0;
      var muted = video.muted;

      current = ratio;
      frame.setAttribute('data-ratio', ratio);

      while (video.firstChild) video.removeChild(video.firstChild);
      if (s.poster) {
        video.setAttribute('poster', s.poster);
      } else {
        video.removeAttribute('poster');
      }
      video.src = s.src;
      video.muted = muted;

      if (keepProgress && t > 0) {
        video.addEventListener('loadedmetadata', function () {
          try { video.currentTime = t; } catch (e) { /* ignore */ }
          if (wasPlaying) {
            var resumed = video.play();
            if (resumed && resumed.catch) resumed.catch(function () {});
          }
        }, { once: true });
        video.load();
      }
    }

    /* Debounced; a mobile toolbar or keyboard only changes height a little,
       so that alone never triggers a source switch. */
    function onResize() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = window.innerWidth;
        var h = window.innerHeight;
        var widthChanged = w !== lastW;
        var bigHeightChange = Math.abs(h - lastH) > 160;
        if (!widthChanged && !bigHeightChange) return;
        lastW = w;
        lastH = h;
        apply(choose(), true);
      }, 250);
    }

    function track(action) {
      if (tracked[action]) return;
      tracked[action] = true;
      var detail = { action: action, ratio: current, film: root.getAttribute('data-oa-film') || 'origin-smart-plus-v6' };
      try {
        document.dispatchEvent(new CustomEvent('osp-ad:film', { detail: detail }));
      } catch (e) { /* ignore */ }
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'osp_ad_film', film_action: action, film_ratio: current });
      }
    }

    function start() {
      root.classList.add('oa-player--started');
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          /* Refused (no gesture, low-power mode): bring the button back. */
          root.classList.remove('oa-player--started');
        });
      }
    }

    apply(choose(), false);
    window.addEventListener('resize', onResize);
    if (window.screen && window.screen.orientation && window.screen.orientation.addEventListener) {
      window.screen.orientation.addEventListener('change', onResize);
    }

    if (play) play.addEventListener('click', start);

    video.addEventListener('play', function () {
      root.classList.add('oa-player--started');
      track('start');
    });
    video.addEventListener('playing', function () {
      root.classList.add('oa-player--has-played', 'oa-player--playing');
    });
    video.addEventListener('pause', function () {
      root.classList.remove('oa-player--playing');
    });
    video.addEventListener('ended', function () {
      root.classList.remove('oa-player--playing');
      track('complete');
    });
    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      var pct = (video.currentTime / video.duration) * 100;
      if (pct >= 25) track('25');
      if (pct >= 50) track('50');
      if (pct >= 75) track('75');
    });

    /* "Watch the film" links anywhere on the page: scroll to the player and
       start it inside the click gesture so mobile browsers allow playback. */
    var watchLinks = document.querySelectorAll('[data-oa-watch]');
    Array.prototype.forEach.call(watchLinks, function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        start();
        root.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  function initFinish(root) {
    var radios = root.querySelectorAll('input[data-oa-variant]');
    var image = root.querySelector('[data-oa-variant-image]');
    var price = root.querySelector('[data-oa-variant-price]');
    var was = root.querySelector('[data-oa-variant-was]');
    var links = root.querySelectorAll('[data-oa-variant-link]');
    var avail = root.querySelector('[data-oa-variant-availability]');

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (image && radio.dataset.image) {
          image.src = radio.dataset.image;
          image.srcset = '';
          if (radio.dataset.alt) image.alt = radio.dataset.alt;
        }
        if (price && radio.dataset.price) price.textContent = radio.dataset.price;
        if (was) {
          if (radio.dataset.was) {
            was.textContent = radio.dataset.was;
            was.hidden = false;
          } else {
            was.hidden = true;
          }
        }
        Array.prototype.forEach.call(links, function (a) {
          var base = a.dataset.base || a.getAttribute('href').split('?')[0];
          a.href = base + '?variant=' + radio.value;
        });
        if (avail) {
          var inStock = radio.dataset.available === 'true';
          avail.textContent = inStock ? avail.dataset.in : avail.dataset.out;
          avail.classList.toggle('oa-avail--out', !inStock);
        }
      });
    });
  }

  /* In-page links (jump to the features, back to top): smooth unless reduced motion,
     and the target receives focus so keyboard users land where they scrolled. */
  function initScrollLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oa-scroll]'), function (link) {
      if (link.dataset.oaScrollBound) return;
      link.dataset.oaScrollBound = '1';
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', href);
        }
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oa-player]'), initPlayer);
    Array.prototype.forEach.call(document.querySelectorAll('[data-oa-finish]'), initFinish);
    initScrollLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when a section is re-rendered. */
  document.addEventListener('shopify:section:load', init);
})();
